import React from 'react'
import styled from 'styled-components'
import SectionHeader from '../SectionHeader'
import { colors, layout, bp } from '../../../theme'

const Main = styled.section`
  padding: ${layout.section};
`

const Container = styled.div`
  max-width: ${layout.maxWidth};
  margin: auto;
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.25rem;

  @media (max-width: ${bp.tablet}) {
    grid-template-columns: 1fr;
  }
`

const Card = styled.div`
  border: 1px solid ${colors.line};
  border-radius: ${layout.radius};
  padding: 1.5rem;

  h3 {
    margin: 0 0 0.5rem;
    color: ${colors.ink};
    font-size: 1.1rem;
  }

  p {
    margin: 0 0 1rem;
    color: ${colors.slate};
    font-size: 0.94rem;
    line-height: 1.6;
  }
`

const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`

const Tag = styled.span`
  background: ${colors.mist};
  border: 1px solid ${colors.line};
  color: ${colors.slate};
  border-radius: 8px;
  padding: 0.35rem 0.7rem;
  font-size: 0.83rem;
  font-weight: 600;
`

const Services = styled.div`
  margin-top: 1.75rem;
  border-top: 1px dashed ${colors.line};
  padding-top: 1.5rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;

  strong {
    color: ${colors.ink};
    margin-right: 0.25rem;
  }

  span {
    color: ${colors.slate};
    font-size: 0.9rem;
  }
`

const cards = [
  {
    title: 'B2B Supply Contracts',
    text: 'Institutional clients engage on 2–3 year supply contracts. Dispensers are installed on agreed terms, with refill schedules managed entirely by Desparclean.',
    tags: ['Hotels & Lodges', 'Schools & Colleges', 'Hospitals & Clinics', 'Garages & Car Washes'],
  },
  {
    title: 'Retail & Direct Consumers',
    text: 'Affordable, quality detergents for households and everyday shoppers — sold in bulk and dispensed by the litre from as low as KES 10 per use.',
    tags: ['Estates', 'Apartments', 'Minimarts', 'Kiosks', 'Households'],
  },
  {
    title: 'Distributors & Retailers',
    text: 'A full Despar Clean catalogue supplied from our Nairobi manufacturing hub to retailers and distributors serving customers nationwide.',
    tags: ['Supermarkets', 'Malls', 'Wholesalers', 'Property Managers'],
  },
]

const WhoWeServe = () => (
  <Main id="who-we-serve">
    <Container>
      <SectionHeader
        kicker="Who We Serve"
        title="From institutions to households, nationwide"
        sub="Desparclean supplies a wide cross-section of institutional, commercial, and individual clients across Kenya — with the NBIoT dispenser targeting high-density and borehole-fed communities."
      />
      <Grid>
        {cards.map((c) => (
          <Card key={c.title}>
            <h3>{c.title}</h3>
            <p>{c.text}</p>
            <Tags>
              {c.tags.map((t) => (
                <Tag key={t}>{t}</Tag>
              ))}
            </Tags>
          </Card>
        ))}
      </Grid>

      <Services>
        <strong>Also available:</strong>
        <span>
          professional cleaning, laundry, carpet cleaning, carwash &amp; auto detailing,
          and fumigation services — offered on request alongside our core manufacturing and
          supply business.
        </span>
      </Services>
    </Container>
  </Main>
)

export default WhoWeServe
